import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, Input, useInfinityScrollObserver } from '@nest/uikit-react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';

export function StorageLocationSelectDialog({
	open,
	onOpenChange,
	onSelect
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onSelect: (value: { id: number; code: string; name?: string }) => void;
}) {
	const [filter, setFilter] = useState('');

	const query = useInfiniteQuery({
		queryKey: ['storage-locations', filter],
		queryFn: async ({ pageParam = 0 }) => {
			return { items: [] as Array<{ id: number; code: string; name?: string }>, nextOffset: null as number | null };
		},
		initialPageParam: 0,
		getNextPageParam: lastPage => lastPage?.nextOffset ?? undefined,
		initialData: { pages: [], pageParams: [] },
		enabled: open
	});

	const items = useMemo(() => query.data?.pages.flatMap(p => p.items) ?? [], [query.data]);
	const { sentinelRef } = useInfinityScrollObserver({ hasNextPage: Boolean(query.hasNextPage), isFetching: query.isFetching, fetchNextPage: () => query.fetchNextPage() });

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Vybrat lokaci</DialogTitle>
				</DialogHeader>
				<div className="space-y-2">
					<Input placeholder="Hledat..." value={filter} onChange={e => setFilter(e.target.value)} />
					<div className="max-h-64 overflow-auto border rounded">
						{items.map(loc => (
							<button key={loc.id} className="w-full text-left px-3 py-2 hover:bg-muted/50" onClick={() => onSelect(loc)}>
								{loc.code}
							</button>
						))}
						<div ref={sentinelRef} />
					</div>
				</div>
				<DialogFooter>
					<Button variant="outline" onClick={() => onOpenChange(false)}>
						Zavřít
					</Button>
					{query.hasNextPage && (
						<Button onClick={() => query.fetchNextPage()} disabled={query.isFetchingNextPage}>
							Načíst další
						</Button>
					)}
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
